var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(Object.assign({}, _vm.style, {backgroundColor: _vm.backgroundColor, height: _vm.height, minHeight: _vm.minHeight}))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }